import { z } from "zod";
import { API_LIMITS, timestampSchema, uuidSchema } from "./primitives";

const problemTypeSchema = z
  .string()
  .min(1)
  .max(256)
  .refine(
    (value) =>
      value === "about:blank" || value.startsWith("https://") || value.startsWith("http://"),
    "Problem type must be about:blank or an HTTP(S) URI.",
  );

export const problemFieldErrorSchema = z
  .object({
    path: z
      .array(z.union([z.string().min(1).max(64), z.number().int().nonnegative()]))
      .min(1)
      .max(20),
    code: z
      .string()
      .min(1)
      .max(64)
      .regex(/^[A-Z0-9_]+$/),
    message: z.string().min(1).max(300),
  })
  .strict();

export const problemResponseSchema = z
  .object({
    type: problemTypeSchema,
    title: z.string().min(1).max(API_LIMITS.problemTitle),
    status: z.number().int().min(400).max(599),
    code: z
      .string()
      .min(1)
      .max(64)
      .regex(/^[A-Z0-9_]+$/),
    detail: z.string().min(1).max(API_LIMITS.problemDetail).optional(),
    instance: z.string().min(1).max(256).optional(),
    requestId: uuidSchema,
    timestamp: timestampSchema,
    errors: z.array(problemFieldErrorSchema).max(API_LIMITS.problemErrors).optional(),
  })
  .strict();

export type ProblemFieldError = z.infer<typeof problemFieldErrorSchema>;
export type ProblemResponse = z.infer<typeof problemResponseSchema>;
